import { Formik } from 'formik';
import noop from 'lodash/noop';
import T from 'prop-types';
import React from 'react';
import { object } from 'yup';
import text from '../../../text';
import { validateEmail } from '../../../validation';
import Button from '../../button/Button';
import Control from '../Control';
var emailSchema = function(param) {
    var isValidUser = param.isValidUser;
    return object().shape({
        email: validateEmail.test('valid-invitee', text('userAlreadyInvited'), function(value) {
            return isValidUser(value);
        })
    });
};
var InviteUsersForm = function(props) {
    var onSubmit = props.onSubmit, isLoading = props.isLoading, isValidUser = props.isValidUser;
    return /*#__PURE__*/ React.createElement("div", {
        className: "InviteUserForm"
    }, /*#__PURE__*/ React.createElement(Formik, {
        initialValues: {
            email: ''
        },
        validationSchema: emailSchema({
            isValidUser: isValidUser
        })
    }, function(param) {
        var handleChange = param.handleChange, handleBlur = param.handleBlur, isValid = param.isValid, values = param.values, errors = param.errors, touched = param.touched, dirty = param.dirty, resetForm = param.resetForm;
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Control, {
            label: text('email'),
            as: "input",
            type: "text",
            name: "email",
            isFailed: touched.email && !!errors.email,
            value: (values === null || values === void 0 ? void 0 : values.email) || '',
            onBlur: handleBlur,
            onChange: function(e) {
                return handleChange(e);
            },
            placeholder: text('enterEmail'),
            validationError: touched.email && errors.email,
            autoComplete: "off"
        }), /*#__PURE__*/ React.createElement(Button, {
            loading: isLoading,
            onClick: function() {
                onSubmit(values.email);
                resetForm();
            },
            disabled: !isValid || !dirty || !isValidUser(values.email)
        }, text('sendInvitation')));
    }));
};
InviteUsersForm.propTypes = {
    onSubmit: T.func.isRequired,
    isLoading: T.bool.isRequired,
    isValidUser: T.func.isRequired
};
InviteUsersForm.defaultProps = {
    onSubmit: noop
};
export default InviteUsersForm;
